export class Category {
    Name: string;
    Sequence: number;       
    CategoryID: number;
    Drafting: boolean;
    SVG: string;
    TaxFree: boolean;

    constructor() {
        this.Name = '';
        this.Sequence = 0;
        this.CategoryID = 0;
        this.Drafting = false;
        this.SVG = '';
        this.TaxFree = false;
    }
}
